import { Route, Redirect } from 'react-router-dom';
import { useAccount } from '../Context/AccountProvider';

export function PrivateRoute({ component: Component, ...rest }) {
    const { accountInfo } = useAccount();

    return (
        <Route {...rest} render={(props) => {
            if (accountInfo.loading) {
                return <div className="white center">Loading...</div>;
            }
            if (!accountInfo.loggedIn) {
                return <Redirect to="/" />;
            }
            return <Component {...props} />;
        }} />
    );
}
